var country = 'usa';
var mapAjaxUrl = 'https://tools.tbmbm.net/geodata/';
var catImages = [];
catImages['Vibrators'] = 'https://cdn.shopify.com/s/files/1/2220/5401/t/15/assets/Image-ClitoralStimulator.png?v=14245024808821453820';
catImages['Dildos'] = 'https://cdn.shopify.com/s/files/1/2220/5401/t/15/assets/Image-Dildo.png?v=10055797133214033000';
catImages['Male Masturbators'] = 'https://cdn.shopify.com/s/files/1/2220/5401/t/15/assets/Image-MaleMasturbator.png?v=10159396387297680785';
catImages['Bondage'] = 'https://cdn.shopify.com/s/files/1/2220/5401/t/15/assets/Image-Bondage.png?v=14330851221099645217';
catImages['Anal'] = 'https://cdn.shopify.com/s/files/1/2220/5401/t/15/assets/Image-ButtPlugs.png?v=16423544075516770728';
catImages['Lingerie'] = 'https://cdn.shopify.com/s/files/1/2220/5401/t/15/assets/Image-Lingerie.png?v=17228764115732853108';
var productJsonPool = [];
var productPool = [];
var maxProductShowing = 6;
var topProductContainer = ''; 


//List Of Categories We Want To Show
let CategoryName = ['Vibrators', 'Dildos','Male Masturbators','Bondage & Fetish','Anal Sex Toys','Lingerie'];

/*List Of Categories We Want To Show
Vibrators, Dildos, Male Masturbators, Bondage & Fetish, Anal Sex Toys, Lingerie
*/

var simplemaps_usmap_mapdata={
  main_settings: {
    //General settings
		width: "700", //or 'responsive'
    background_color: "#FFFFFF",
    background_transparent: "yes",
    popups: "off",
    
		//State defaults
		state_description: "",
    state_color: "#F5D1D6",
    state_hover_color: "#e60060",
    border_size: 1.5,
    border_color: "#ffffff",
    all_states_inactive: "no",
    all_states_zoomable: "no",
    
		//Location defaults
		location_description: "Location description",
    location_color: "#00f",
    location_opacity: 0.8,
    location_hover_opacity: 0.5,
    location_url: "",
    location_size: 20,
    location_type: "circle",
    location_border_color: "#FFFFFF",
    location_border: 2,
    location_hover_border: 4,
    all_locations_inactive: "no",
    all_locations_hidden: "no",
    
		//Label defaults
		label_color: "#ffffff",
    label_hover_color: "#ffffff",
    label_size: 22,
    label_font: "Arial",
    hide_labels: "no",
    label_opacity: 0,
    label_hover_opacity: 1,
   
		//Zoom settings
		manual_zoom: "no",
    back_image: "no",
    arrow_box: "no",
    navigation_size: "40",
    navigation_color: "#f7f7f7",
    navigation_border_color: "#636363",
    initial_back: "no",
    initial_zoom: -1,
    initial_zoom_solo: "no",
    region_opacity: 1,
    region_hover_opacity: 0.6,
    zoom_out_incrementally: "yes",
    zoom_percentage: 0.99,
    zoom_time: 0.5,
    
		//Popup settings
		popup_color: "white",
    popup_opacity: 0.9,
    popup_shadow: 1,
    popup_corners: 5,
    popup_font: "12px/1.5 Verdana, Arial, Helvetica, sans-serif",
    popup_nocss: "no",
    
		//Advanced settings
		div: "map",
    auto_load: "yes",
    rotate: "0",
    url_new_tab: "yes",
    images_directory: "default",
    import_labels: "no",
    fade_time: 0.1,
    link_text: "View Website"
  },
  state_specific: {
    HI: {
      name: "Hawaii",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    AK: {
      name: "Alaska",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    FL: {
      name: "Florida",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default",
      inactive: "no"
    },
    NH: {
      name: "New Hampshire",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    VT: {
      name: "Vermont",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    ME: {
      name: "Maine",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    RI: {
      name: "Rhode Island",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    NY: {
      name: "New York",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    PA: {
      name: "Pennsylvania",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    NJ: {
      name: "New Jersey",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    DE: {
      name: "Delaware",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    MD: {
      name: "Maryland",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    VA: {
      name: "Virginia",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    WV: {
      name: "West Virginia",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    OH: {
      name: "Ohio",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    IN: {
      name: "Indiana",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    IL: {
      name: "Illinois",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    CT: {
      name: "Connecticut",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    WI: {
      name: "Wisconsin",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    NC: {
      name: "North Carolina",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    DC: {
      name: "District of Columbia",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    MA: {
      name: "Massachusetts",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    TN: {
      name: "Tennessee",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    AR: {
      name: "Arkansas",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    MO: {
      name: "Missouri",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    GA: {
      name: "Georgia",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    SC: {
      name: "South Carolina",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    KY: {
      name: "Kentucky",
      description: "default",
      color: "default",
      zoomable: "no",
      hover_color: "default",
      url: "default"
    },
    AL: {
      name: "Alabama",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    LA: {
      name: "Louisiana",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    MS: {
      name: "Mississippi",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    IA: {
      name: "Iowa",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    MN: {
      name: "Minnesota",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    OK: {
      name: "Oklahoma",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    TX: {
      name: "Texas",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    NM: {
      name: "New Mexico",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    KS: {
      name: "Kansas",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    NE: {
      name: "Nebraska",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    SD: {
      name: "South Dakota",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    ND: {
      name: "North Dakota",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    WY: {
      name: "Wyoming",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    MT: {
      name: "Montana",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    CO: {
      name: "Colorado",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    UT: {
      name: "Utah",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    AZ: {
      name: "Arizona",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    NV: {
      name: "Nevada",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    OR: {
      name: "Oregon",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    WA: {
      name: "Washington",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    CA: {
      name: "California",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    MI: {
      name: "Michigan",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    ID: {
      name: "Idaho",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default"
    },
    GU: {
      name: "Guam",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default",
      hide: "yes"
    },
    VI: {
      name: "Virgin Islands",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default",
      hide: "yes"
    },
    PR: {
      name: "Puerto Rico",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default",
      hide: "yes"
    },
    AS: {
      name: "American Samoa",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default",
      hide: "yes"
    },
    MP: {
      name: "Northern Mariana Islands",
      description: "default",
      color: "default",
      hover_color: "default",
      url: "default",
      hide: "yes"
    }
  },
  locations: {
    "0": {
      name: "New York",
      lat: 40.71,
      lng: -74,
      description: "default",
      color: "default",
      url: "default",
      type: "default",
      size: "default"
    },
    "1": {
      name: "Anchorage",
      lat: 61.2180556,
      lng: -149.9002778,
      color: "default",
      type: "circle"
    }
  },
  locations: {
  },
  labels: {
    NH: {
      parent_id: "NH",
      x: "932",
      y: "183",
      pill: "yes",
      width: 45,
      display: "all"
    },
    VT: {
      parent_id: "VT",
      x: "883",
      y: "243",
      pill: "yes",
      width: 45,
      display: "all"
    },
    RI: {
      parent_id: "RI",
      x: "932",
      y: "273",
      pill: "yes",
      width: 45,
      display: "all"
    },
    NJ: {
      parent_id: "NJ",
      x: "883",
      y: "273",
      pill: "yes",
      width: 45,
      display: "all"
    },
    DE: {
      parent_id: "DE",
      x: "883",
      y: "303",
      pill: "yes",
      width: 45,
      display: "all"
    },
    MD: {
      parent_id: "MD",
      x: "932",
      y: "303",
      pill: "yes",
      width: 45,
      display: "all"
    },
    DC: {
      parent_id: "DC",
      x: "884",
      y: "332",
      pill: "yes",
      width: 45,
      display: "all"
    },
    MA: {
      parent_id: "MA",
      x: "932",
      y: "213",
      pill: "yes",
      width: 45,
      display: "all"
    },
    CT: {
      parent_id: "CT",
      x: "932",
      y: "243",
      pill: "yes",
      width: 45,
      display: "all"
    },
    HI: {
      parent_id: "HI",
      x: 305,
      y: 565,
      pill: "yes"
    },
    AK: {
      parent_id: "AK",
      x: "113",
      y: "495"
    },
    FL: {
      parent_id: "FL",
      x: "773",
      y: "510"
    },
    ME: {
      parent_id: "ME",
      x: "893",
      y: "85"
    },
    NY: {
      parent_id: "NY",
      x: "815",
      y: "158"
    },
    PA: {
      parent_id: "PA",
      x: "786",
      y: "210"
    },
    VA: {
      parent_id: "VA",
      x: "790",
      y: "282"
    },
    WV: {
      parent_id: "WV",
      x: "744",
      y: "270"
    },
    OH: {
      parent_id: "OH",
      x: "700",
      y: "240"
    },
    IN: {
      parent_id: "IN",
      x: "650",
      y: "250"
    },
    IL: {
      parent_id: "IL",
      x: "600",
      y: "250"
    },
    WI: {
      parent_id: "WI",
      x: "575",
      y: "155"
    },
    NC: {
      parent_id: "NC",
      x: "784",
      y: "326"
    },
    TN: {
      parent_id: "TN",
      x: "655",
      y: "340"
    },
    AR: {
      parent_id: "AR",
      x: "548",
      y: "368"
    },
    MO: {
      parent_id: "MO",
      x: "548",
      y: "293"
    },
    GA: {
      parent_id: "GA",
      x: "718",
      y: "405"
    },
    SC: {
      parent_id: "SC",
      x: "760",
      y: "371"
    },
    KY: {
      parent_id: "KY",
      x: "680",
      y: "300"
    },
    AL: {
      parent_id: "AL",
      x: "655",
      y: "405"
    },
    LA: {
      parent_id: "LA",
      x: "550",
      y: "435"
    },
    MS: {
      parent_id: "MS",
      x: "600",
      y: "405"
    },
    IA: {
      parent_id: "IA",
      x: "525",
      y: "210"
    },
    MN: {
      parent_id: "MN",
      x: "506",
      y: "124"
    },
    OK: {
      parent_id: "OK",
      x: "460",
      y: "360"
    },
    TX: {
      parent_id: "TX",
      x: "425",
      y: "435"
    },
    NM: {
      parent_id: "NM",
      x: "305",
      y: "365"
    },
    KS: {
      parent_id: "KS",
      x: "445",
      y: "290"
    },
    NE: {
      parent_id: "NE",
      x: "420",
      y: "225"
    },
    SD: {
      parent_id: "SD",
      x: "413",
      y: "160"
    },
    ND: {
      parent_id: "ND",
      x: "416",
      y: "96"
    },
    WY: {
      parent_id: "WY",
      x: "300",
      y: "180"
    },
    MT: {
      parent_id: "MT",
      x: "280",
      y: "95"
    },
    CO: {
      parent_id: "CO",
      x: "320",
      y: "275"
    },
    UT: {
      parent_id: "UT",
      x: "223",
      y: "260"
    },
    AZ: {
      parent_id: "AZ",
      x: "205",
      y: "360"
    },
    NV: {
      parent_id: "NV",
      x: "140",
      y: "235"
    },
    OR: {
      parent_id: "OR",
      x: "100",
      y: "120"
    },
    WA: {
      parent_id: "WA",
      x: "130",
      y: "55"
    },
    ID: {
      parent_id: "ID",
      x: "200",
      y: "150"
    },
    CA: {
      parent_id: "CA",
      x: "79",
      y: "285"
    },
    MI: {
      parent_id: "MI",
      x: "663",
      y: "185"
    },
    PR: {
      parent_id: "PR",
      x: "620",
      y: "545"
    },
    GU: {
      parent_id: "GU",
      x: "550",
      y: "540"
    },
    VI: {
      parent_id: "VI",
      x: "680",
      y: "519"
    },
    MP: {
      parent_id: "MP",
      x: "570",
      y: "575"
    },
    AS: {
      parent_id: "AS",
      x: "665",
      y: "580"
    }
  }
};

/*
,
		  "1": {
		    name: "Halifax",
		    lat: 44.6488625,
		    lng: -63.5753196,
		    color: "default",
				description: ""
		  }
*/


var mapEle = null;
var mapData = (country == 'ca' ? simplemaps_canadamap_mapdata : simplemaps_usmap_mapdata);
var regions = [];
$(function(){
	$(".region").on('change', regionUpdate);
	
  
  	$("#top_city_loading, #large_city_loading").append($("#loading_svg").clone().removeAttr('id'));
  
	$.get(window.mapAjaxUrl+'init-data?country='+country, function(data, status){
		var regions = data.regions;
		window.regions = regions;
		populateTopCity(data.topRanks);
      	populateLargeCity(data.largeCities);
		updateRegion();
      	$("#top_city_loading, #large_city_loading").html('');
	});
	
	if(country == 'ca'){
		mapEle = simplemaps_canadamap;
		mapEle.hooks.complete = function(){
										//mapEle.state_zoom('ON');
												};
	}else{
		mapEle = simplemaps_usmap;
		mapEle.hooks.complete = function(){
										//mapEle.state_zoom('ON');
												};
	}
	
	$("#single_city_frm").submit(function(e){
		e.preventDefault;
		singleCitySelected();		
		return false;
	});
	
	
	$("#compare_city_frm").submit(function(e){
		e.preventDefault;
		compareCitySelected();		
		return false;
	});
	$(document).on('click', ".clickable-city", singleCityClicked);
	
});

function populateTopCity(ranks){
  	/*
	var first = ranks.splice(0,1)[0];
	var source = document.getElementById("entry-top-single-city").innerHTML;
	var template = Handlebars.compile(source);
	var context = first;
	var resultHtml = template(context);
  
	$("#top_city").html(resultHtml);
	*/
	// rows
	for(var i=0; i <= 9; i++){
		var rowRanks = ranks.splice(0,1);
		
		var source = document.getElementById("entry-top-city-row").innerHTML;
		var template = Handlebars.compile(source);
		var context = {cities: rowRanks};
		var resultHtml = template(context);
		$("#top_city_ranks .CityRowDivHolder").eq(i).html(resultHtml);
	}
	
	
}

function populateLargeCity(ranks){
  	/*
	var first = ranks.splice(0,1)[0];
	var source = document.getElementById("entry-top-single-city").innerHTML;
	var template = Handlebars.compile(source);
  	first.rank = 1;
	var context = first;
	var resultHtml = template(context);
  
	$("#large_city").html(resultHtml);
	*/
	// rows
	for(var i=0; i <= 9; i++){
		var rowRanks = ranks.splice(0,1);
      	for(var j=0; j<rowRanks.length; j++){
        	rowRanks[j].rank = i+1; //(i-1) * 2 + j +3;
      	}
		var source = document.getElementById("entry-top-city-row").innerHTML;
		var template = Handlebars.compile(source);
		var context = {cities: rowRanks};
		var resultHtml = template(context);
		$("#large_city_ranks .CityRowDivHolder").eq(i).html(resultHtml);
	}
	
	
}

function singleCityClicked(){
  var formData = "country="+window.country+"&"+$(this).data('qstr');
  $("#single_city_ranks, #single_city_top_products").empty().html($("#loading_svg").clone().removeAttr('id'));
  buildSingleCityResult(formData);
  
  setTimeout(function(){
                            $('html, body').animate({
                                              scrollTop: $("#single_city_showcase").offset().top
                                          }, 1000);
  						}, 1500);
  
}
function singleCitySelected(){
	
	var formData = {country: country, region_1: $("#region_1").val(), city_1: $("#city_1").val()};
	
	if(!formData.region_1 || !formData.city_1) return false;
	
  	
  	$("#single_city_ranks, #single_city_top_products").empty().html($("#loading_svg").clone().removeAttr('id'));
	
	
    buildSingleCityResult(formData);
	
} 

function buildSingleCityResult(formData){
  $.post(window.mapAjaxUrl+'get-city-ranks', formData, function(data, status){
  	$("#single_city_loading").empty();
		var finalHtml = '';
		for(var i=0; i<data.ranks.length; i++){
			var d = data.ranks[i];
			var source = document.getElementById("entry-single-rank").innerHTML;
			var template = Handlebars.compile(source);
			var context = { img: window.catImages[d.category], rank: numToRank(d.rank), category: d.category, url: d.url };
			var html = template(context);
			finalHtml += (html);
			
		}
		
		mapData.locations =[ 
			   {
				    name: data.city.name,
				    lat: data.city.lat,
				    lng: data.city.lng,
				    color: "default",
					description: ""
				  }
		  ];
		
		$("#single_city_container, #top_city_ranks, #large_city_ranks").hide();
		mapEle.refresh();
		mapEle.state_zoom(data.city.region);
		$("#single_city_ranks").html(finalHtml);
      	$("#single_city_rank").html(data.city.rank);
      	$("#single_city_rank_count").html(data.city.rankCount);
  
        $("#single_big_city_rank").html(data.city.bigCityRank);
      	$("#single_big_city_rank_count").html(data.city.bigRankCount);


    
      	$(".topSellingTitle").css("display","block");
    	
    	$("#fav_flavr").text(data.secrets.lube);
    	$("#fav_dbsm").text(data.secrets.bdsm);
        $("#fav_analtoys").text(data.secrets.anal_toys);
        $("#fav_dildolength").text(data.secrets.dildo_length+"''");
    
    
    	$(".topSecret, .topSecretTitle").css("display","block");
      
      
      	$(".CityName").text(data.city.name);
      	$(".CityProvince").text(data.city.region);
        $("#single_city_showcase").show();
      	$(".selectedCityDiv").css("display","inline-block");
        if(!data.city.bigCityRank){
          $("#bigSingleCityRank").hide();
        }
      
		$("#compare_city_container").show();
		// copy current city to compare form
		$("#region_2").val($("#region_1").val());
		$("#city_2").html($("#city_1").html());
		$("#city_2").val($("#city_1").val());
      	
      	$("#single_city_top_products").html(buildProductLoadingBlocks(6));
      	getTopProducts(data.top_products, data.domain, "#single_city_top_products");
   });   	
}

function buildProductLoadingBlocks(num){
 	var html = '';
  	var l = $("#loading_svg").clone().removeAttr('id');
  	for(var i =0; i<num; i++){
    	html += '<div class="ProductHolderDiv">'+l.html()+'</div>';
  	}
  	return html;
}


function compareCitySelected(){
  	
  	$("#compare_city_ranks").empty().html($("#loading_svg").clone().removeAttr('id'));
  
	var formData = {country: country, region_2: $("#region_2").val(), city_2: $("#city_2").val(), region_3: $("#region_3").val(), city_3: $("#city_3").val()};
	if(!formData.region_2 || !formData.city_2 || !formData.region_3 || !formData.city_3) return false;
	$.post(window.mapAjaxUrl+'get-city-ranks', formData, function(data, status){
		var finalHtml = '';
		var city_1 = data[0];
		var city_2 = data[1];
		$("#single_city_showcase").hide();
		mapData.locations =[ 
			   {
				    name: city_1.city.name,
				    lat: city_1.city.lat,
				    lng: city_1.city.lng,
				    color: "default",
					description: ""
				  },
			  {
				    name: city_2.city.name,
				    lat: city_2.city.lat,
				    lng: city_2.city.lng,
				    color: "default",
					description: ""
				  },  
		  ];
	 	  mapEle.refresh();
	 	  if(city_1.city.region == city_2.city.region)
	 		  mapEle.state_zoom(city_1.city.region);
	 	  else{
	 		 mapEle.back();
	 	  }
	 	  
	 	var matchedRanks = [];  
	 	var city_1_overall_rank = 0, city_2_overall_rank = 0;
	 	for(var i = 0; i < city_1.ranks.length; i++){
	 		for(var j = 0; j < city_2.ranks.length; j++){
	 			if(city_1.ranks[i].category == city_2.ranks[j].category){
	 				matchedRanks.push({category: city_1.ranks[i].category, 
                                        img: window.catImages[city_1.ranks[i].category],
	 									city_1_name: city_1.city.name, 
	 									city_1_rank: numToRank(city_1.ranks[i].rank), 
	 									city_2_name: city_2.city.name, 
	 									city_2_rank: numToRank(city_2.ranks[j].rank),
                                       	rank_count: city_1.city.rankCount});
	 				city_1_overall_rank += parseInt(city_1.ranks[i].rank);
	 				city_2_overall_rank += parseInt(city_2.ranks[j].rank);
	 			}
	 		}
	 	}   
	 	
	 	var winnerCity = ((city_2_overall_rank / city_2.ranks.length) < (city_1_overall_rank / city_2.ranks.length) ? city_2.city.name : city_1.city.name);
      	var winnderProvince = (city_1.city.name == winnerCity?city_1.city.region: city_2.city.region);
	 	
	 	var source = document.getElementById("compare-result").innerHTML;
		var template = Handlebars.compile(source);
      
      var context = { entry_compare_ranks: matchedRanks, winner:winnerCity, winnderProvince: winnderProvince, city_1: city_1.city.name, city_1_region: city_1.city.region, city_2: city_2.city.name, city_2_region: city_2.city.region };
		var resultHtml = template(context);
		$("#compare_city_ranks").html(resultHtml);
      	$(".topCategoryTitle").css("display","block");
      $(".topCategoryTitle").prependTo(".rankingCityVersus");
      
      $(".CityVersus1").text(city_1.city.name);
      $(".ProvinceVersus1").text(city_1.city.region);
      $(".CityVersus2").text(city_2.city.name);
      $(".ProvinceVersus2").text(city_2.city.region);
      
      
      
      $("#cmpCity1TopProds").data('done',0).html(buildProductLoadingBlocks(6));
      $("#cmpCity2TopProds").html(buildProductLoadingBlocks(6));
      getTopProducts(city_1.top_products, city_1.domain, "#cmpCity1TopProds");
      
      
      var city2TopProdTimer = setInterval(function(){
        if($("#cmpCity1TopProds").data('done')){
         	clearInterval(city2TopProdTimer);
          	$("#cmpCity2TopProds").data('done',0).html('');
      		getTopProducts(city_2.top_products, city_2.domain, "#cmpCity2TopProds");
        }
      });
      
      
      $('html, body').animate({
                    scrollTop: $("#compare_city_ranks").offset().top
                }, 1000);
      
	});
	
	
}

function numToRank(num) {
    var j = num % 10,
        k = num % 100;
    if (j == 1 && k != 11) {
        return num + "st";
    }
    if (j == 2 && k != 12) {
        return num + "nd";
    }
    if (j == 3 && k != 13) {
        return num + "rd";
    }
    return num + "th";
}






function getTopProducts(products, domain, topProductContainer){
  	window.productJsonPool = [];
  	window.topProductContainer = topProductContainer;
  	productPool = products;
  	requestProductJson();
}

function requestProductJson(){
  	if(window.productPool.length < 1 || window.productJsonPool.length >= window.maxProductShowing) {
    	showTopProducts();
      	return;
  	}
  	var p = window.productPool.shift();
  	if(!p) return;
    jQuery.ajax({
      type: 'GET',
      url: '/products/' + p.handle + '.json',
      success: function(response) {
        window.productJsonPool.push(response.product);
        requestProductJson();
      },
      error: function(error) {
        console.log("Error: "+ error);
      }
    });
}

function showTopProducts(){
  	$(window.topProductContainer).html('');
  	var p = window.productJsonPool.shift();
  	var allHtml = '';
  	while(p){
      	var source = document.getElementById("entry-top-product").innerHTML;
		var template = Handlebars.compile(source);
      	var context = {link: '/products/'+p.handle, img: p.image.src, name: p.title, price: p.variants[0].price, pid:  p.variants[0].id};
      	//console.log(context);
		allHtml += template(context);
      	
    	p = window.productJsonPool.shift();
  	}
  
  	$(window.topProductContainer).data('done',1).html(allHtml);
}





function citySelected(){
	var selected = $(this).val();
	if(!selected) return;
	
	
	// refresh page to build the map.
} 
function updateRegion(){
	 
	$(".region").each(function(){
		$(this).find('option').not(':first').remove();
		for(var i = 0; i<window.regions.length; i++){
			$(this).append(new Option(window.regions[i].name,window.regions[i].id));
		}
	});
	
}

function updateCity(index, cities){
	var city = $("#city_"+index)
	city.find('option').not(':first').remove();
	for(var i = 0; i<cities.length; i++){
		city.append(new Option(cities[i].name,cities[i].name));
	}
}

function regionUpdate(){
	var sourceId = $(this).attr('id');
	var index = sourceId.split('_')[1];
	
	
	$("#city_"+index).removeAttr('disabled');
	var cities = [];
	var selected = $(this).val();
  
	if(!selected) updateCity(cities);
	$.get(window.mapAjaxUrl+'get-city?country='+country+"&region="+selected, function(data, status){
      console.log(index, data);
		updateCity(index,data);
	});
}
